import React from 'react';
import PropTypes from 'prop-types';
import {
  MeetingProvider,
  GlobalStyles,
  // NotificationProvider,
} from 'amazon-chime-sdk-component-library-react';

import { ThemeProvider } from 'styled-components';
import { LastLocationProvider } from 'react-router-last-location';
import meetingConfig from '@components/Conference/config/meetingConfig';
import ErrorProvider from '@components/Conference/providers/errorProvider';
import { ConferencingProvider } from '@components/Conference/providers/conferencingProvider';
import Notifications from '@components/Conference/providers/notifications';
import { NavigationProvider } from '@components/Conference/providers/navigationProvider';
import { chatVirtualHelpTheme as DefaultTheme } from '@components/Conference/config/theme';

const ConferenceWrapper = ({
  children,
  prefix,
  theme,
  isHelpDesk
}) => {
  const activeTheme = !theme ? DefaultTheme : theme;

  return (
    <ThemeProvider theme={activeTheme}>
      <GlobalStyles />
      {/* <NotificationProvider> */}
        <Notifications />
        <ErrorProvider>
            <MeetingProvider  {...meetingConfig}>
              <ConferencingProvider isHelpDesk={isHelpDesk}>
                <LastLocationProvider>
                  <NavigationProvider prefix={prefix}>
                    {children}
                  </NavigationProvider>
                </LastLocationProvider>
              </ConferencingProvider>
            </MeetingProvider>
        </ErrorProvider>
      {/* </NotificationProvider> */}
    </ThemeProvider>
  );
};

ConferenceWrapper.propTypes = {
  children: PropTypes.node,
  prefix: PropTypes.string,
  theme: PropTypes.any,
  isHelpDesk: PropTypes.bool.isRequired
};

ConferenceWrapper.defaultProps = {
  isHelpDesk: false
};

export default ConferenceWrapper;